import { HtmlParser } from '@angular/compiler';
import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { ConfirmDialogComponent } from '@shared/ui/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor() { }
  private container?: ViewContainerRef;
  private dialogRef?: ComponentRef<ConfirmDialogComponent>;

  // Set the container (from parent component)
  setViewContainerRef(container: ViewContainerRef) {
    this.container = container;
  }

  // get the container
  getViewContainerRef() {
    return this.container;
  }


  openDialog(data: {
    isOpen: boolean;
    isDialogLoading: boolean;
    title: string;
    description: string | HtmlParser;
    loadingText: string;
    action?: Function;
    onClose?: Function;
    isHTMLQuestion?: boolean;
    showQuestionGif?: boolean;
    bgConfirmButton?: 'danger' | 'primary';
    disableActionButton?: boolean;
    showCancelButton?: boolean;
  }) {
    console.log('Opening confirm dialog with data:', data);
    if (!this.container) throw new Error('ViewContainerRef is not set.');

    // If already open, just update values
    if (this.dialogRef) {
      this.updateDialog({
        isDialogLoading: data.isDialogLoading,
        description: data.description,
        loadingText: data.loadingText,
      });
      return;
    }

    // Create new dialog if none exists
    this.container.clear();
    this.dialogRef = this.container.createComponent(ConfirmDialogComponent);

    const instance = this.dialogRef.instance;
    instance.isDialogLoading = data.isDialogLoading;
    instance.title = data.title;
    instance.description = data.description;
    instance.dialogLoadingText = data.loadingText;
    instance.isOpen = data.isOpen;
    instance.isHTMLQuestion = data.isHTMLQuestion ?? this.detectHTML(data.description);
    instance.showQuestionGif = data.showQuestionGif ?? true;
    instance.bgConfirmButton = data.bgConfirmButton || 'primary';
    instance.disableActionButton = data.disableActionButton || false;
    instance.showCancelButton = data.showCancelButton || true;
    instance.action = data.action || (() => alert('No action defined'));

    instance.close.subscribe(() => {
      this.dialogRef?.destroy();
      this.dialogRef = undefined;
      data.onClose?.();
    });
  }

  // Update dialog properties
  updateDialog(data: Partial<{ isDialogLoading: boolean; description: string | HtmlParser; loadingText: string; isOpen: boolean }>) {
    if (!this.dialogRef) return;
    const instance = this.dialogRef.instance;
  
    if (data.isDialogLoading !== undefined) instance.isDialogLoading = data.isDialogLoading;
    if (data.description !== undefined) instance.description = data.description;
    if (data.loadingText !== undefined) instance.dialogLoadingText = data.loadingText;
  
    // Close & cleanup if isOpen is explicitly set to false
    if (data.isOpen === false) {
      instance.isDialogLoading = false;
      instance.isOpen = false;
      setTimeout(() => {
        this.dialogRef?.destroy();
        this.dialogRef = undefined;
      }, 300); // Allow animation to finish
    }
  }

  private detectHTML(desc: string | HtmlParser): boolean {
    return typeof desc === 'string' && /<\/?[a-z][\s\S]*>/i.test(desc);
  }
  
}
